import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// --- ASSETS (Kiểm tra lại đường dẫn file của bạn) ---
import back from './image/booking/back.png';
import Timeline from './timeline_w';

// --- IMPORT SCHEDULES (9 Đỉnh núi) ---
import TaChiNhuSchedule from './TaChiNhu_book';
import LaoThanSchedule from './LaoThan_book';
import NhiuCoSanSchedule from './NhiuCoSan_book';
import PhuSaphinSchedule from './PhuSaPhin_book';
import KyQuanSanSchedule from './KyQuanSan_book';
import TaLienSonSchedule from './TaLienSon_book';
import LungCungSchedule from './LungCung_book';
import PutalengSchedule from './Putaleng_book';
import SamuSchedule from './SaMu_book';

// DỮ LIỆU ĐẦY ĐỦ CỦA 9 NGỌN NÚI
const MOUNTAINS = [
  { id: 'lt', name: 'LÀO THẨN', level: 'Dễ', distance: '16km', cost: 1500000,  bus: '500.000đ (Giường nằm)', guider: 2000000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm', type: 'newbie', tag: 'Săn mây Y Tý', component: LaoThanSchedule },
  { id: 'sm', name: 'SAMU', level: 'Dễ', distance: '14km', cost: 1600000, bus: '500.000đ (Giường nằm)', guider: 2600000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm', type: 'newbie', tag: 'Rừng rêu cổ tích', component: SamuSchedule },
  { id: 'lc', name: 'LÙNG CÚNG', level: 'Vừa', distance: '15km', cost: 1800000, bus: '500.000đ (Giường nằm)', guider: 2600000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm', type: 'newbie', tag: 'Thung lũng gió', component: LungCungSchedule },
  { id: 'ncs', name: 'NHÌU CỒ SAN', level: 'Vừa', distance: '18km', cost: 1800000, bus: '500.000đ (Giường nằm)',guider: 2600000, car: '10.500.000 Xe 16 chỗ ',  date: '2 Ngày 2 đêm', type: 'pro', tag: 'Thác Ong Chúa', component: NhiuCoSanSchedule },
  { id: 'tcn', name: 'TÀ CHÌ NHÙ', level: 'Khó', distance: '22km', cost: 2000000, bus: '600.000đ (Limousine)', guider: 2000000, car: '10.500.000 Xe 16 chỗ )', date: '2 Ngày 2 đêm',  type: 'pro', tag: 'Đỉnh hoa tím', component: TaChiNhuSchedule },
  { id: 'tls', name: 'TẢ LIÊN SƠN', level: 'Vừa', distance: '20km', cost: 2000000, bus: '600.000đ (Limousine)', guider: 2600000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm',  type: 'pro', tag: 'Rừng cổ thụ', component: TaLienSonSchedule },
  { id: 'kqs', name: 'KỲ QUAN SAN', level: 'Rất Khó', distance: '34km', cost: 2500000, bus: '600.000đ (Limousine)',guider: 3400000, car: '10.500.000 Xe 16 chỗ ', date: '3 Ngày 3 đêm',  type: 'pro', tag: 'Bình minh mây', component: KyQuanSanSchedule },
  { id: 'psp', name: 'PHU SA PHÌN', level: 'Khó', distance: '25km', cost: 2500000, bus: '700.000đ (Xe riêng)', guider: 2600000, car: '10.500.000 Xe 16 chỗ ', date: '2 Ngày 2 đêm',  type: 'pro', tag: 'Hoang sơ', component: PhuSaphinSchedule },
  { id: 'ptl', name: 'PUTALENG', level: 'Rất Khó', distance: '36km', cost: 3000000, bus: '700.000đ (Xe riêng)', guider: 3000000, car: '10.500.000 Xe 16 chỗ ', date: '3 Ngày 3 đêm',  type: 'pro', tag: 'Nóc nhà thứ 3', component: PutalengSchedule },
];

export default function QuickTrekMaster() {
  const { pathname } = useLocation();
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState(MOUNTAINS[0]);
  const [groupSize, setGroupSize] = useState(1);
  const [days, setDays] = useState(2); // Lựa chọn 2 ngày hoặc 3 ngày

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  const filteredMountains = filter === 'all' ? MOUNTAINS : MOUNTAINS.filter(m => m.type === filter);
  const totalTourCost = (selected.cost * groupSize);

  // Khai báo Dynamic Component cho lịch trình
  const ActiveSchedule = selected.component;

  return (
    <div className="relative min-h-screen font-sans bg-[#F0F2F5] antialiased">
      {/* Background mờ ảo sang trọng */}
      <div className="fixed inset-0 z-0" style={{ backgroundImage: `url(${back})`, backgroundSize: 'cover' }}>
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px] z-0"></div>
      </div>
    
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12 md:py-20">
        
        {/* --- 1. HEADER & INTERACTIVE FILTER (Thấu hiểu khách hàng) --- */}
        <header className="mb-12 text-center">
          <h1 className="text-6xl md:text-8xl font-black text-white mb-6 tracking-tighter uppercase">
            QUICK <span className="text-sky-400 italic">TREK</span>
          </h1>
          <p className="text-white/70 italic mb-8 font-medium italic">"Chuyến đi này, bạn muốn thử thách bản thân ở mức độ nào?"</p>
          
          <div className="flex flex-wrap justify-center gap-3 bg-white/10 p-2 rounded-[30px] backdrop-blur-md max-w-2xl mx-auto border border-white/20">
            <button onClick={() => {setFilter('newbie'); setSelected(MOUNTAINS[0]);}} className={`flex-1 px-6 py-3 rounded-[24px] font-black text-[10px] uppercase transition-all ${filter === 'newbie' ? 'bg-white text-slate-900 shadow-xl' : 'text-white hover:bg-white/10'}`}>🌿 Người mới (Dễ/Vừa)</button>
            <button onClick={() => {setFilter('pro'); setSelected(MOUNTAINS[3]);}} className={`flex-1 px-6 py-3 rounded-[24px] font-black text-[10px] uppercase transition-all ${filter === 'pro' ? 'bg-white text-slate-900 shadow-xl' : 'text-white hover:bg-white/10'}`}>🔥 Thử thách (Khó)</button>
            <button onClick={() => setFilter('all')} className={`flex-1 px-6 py-3 rounded-[24px] font-black text-[10px] uppercase transition-all ${filter === 'all' ? 'bg-white text-slate-900 shadow-xl' : 'text-white hover:bg-white/10'}`}>Tất cả cung đường</button>
          </div>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          
          {/* --- 2. SIDEBAR DANH SÁCH NÚI --- */}
          <div className="lg:col-span-4 space-y-3 max-h-[75vh] overflow-y-auto pr-2 lg:sticky lg:top-10 custom-scrollbar">
            <p className="text-white/40 text-[9px] font-black uppercase tracking-[0.3em] mb-4 pl-4">Khám phá Tây Bắc</p>
            {filteredMountains.map((m) => (
              <button
                key={m.id}
                onClick={() => setSelected(m)}
                className={`w-full p-6 rounded-[35px] text-left transition-all border-2 duration-500 ${
                  selected.id === m.id ? 'bg-white border-white shadow-[0_20px_50px_rgba(0,0,0,0.3)] scale-105' : 'bg-white/5 border-transparent text-white/50 hover:bg-white/10'
                }`}
              >
                <div className="flex justify-between items-center">
                  <div>
                    <p className={`text-[9px] font-bold uppercase tracking-widest ${selected.id === m.id ? 'text-sky-500' : 'text-white/90'}`}>{m.tag}</p>
                    <p className={`text-xl font-black ${selected.id === m.id ? 'text-slate-900' : 'text-white'}`}>{m.name}</p>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-[9px] font-black uppercase ${selected.id === m.id ? 'bg-sky-100 text-sky-600' : 'bg-white/10 text-white'}`}>{m.level}</span>
                </div>
              </button>
            ))}
          </div>

          {/* --- 3. MAIN DASHBOARD: TÍNH TOÁN & LỊCH TRÌNH --- */}
          <div className="lg:col-span-8 space-y-6">
            <div className="bg-white rounded-[55px] p-8 md:p-14 shadow-2xl border border-white/50">
              
              {/* THÔNG SỐ KỸ THUẬT (Spec Cards) */}
              <div className="grid grid-cols-3 gap-4 mb-12 pb-10 border-b border-slate-100">
                <div className="text-center group">
                  <p className="text-[10px] font-black text-slate-300 uppercase tracking-widest mb-2 group-hover:text-sky-500 transition-colors">Độ khó</p>
                  <p className="text-xl md:text-2xl font-black text-slate-800 tracking-tighter">{selected.level}</p>
                </div>
                <div className="text-center border-x border-slate-100 group">
                  <p className="text-[10px] font-black text-slate-300 uppercase tracking-widest mb-2 group-hover:text-sky-500 transition-colors">Chiều dài</p>
                  <p className="text-xl md:text-2xl font-black text-slate-800 tracking-tighter">{selected.distance}</p>
                </div>
                <div className="text-center group">
                  <p className="text-[10px] font-black text-slate-300 uppercase tracking-widest mb-2 group-hover:text-sky-500 transition-colors">Giá gốc</p>
                  <p className="text-xl md:text-2xl font-black text-sky-600 tracking-tighter">{selected.cost.toLocaleString()}đ</p>
                </div>
              </div>

              {/* CÔNG CỤ TÍNH TOÁN CHI PHÍ & LỰA CHỌN NGÀY */}
              <div className="grid md:grid-cols-2 gap-12 mb-16">
                <div className="space-y-6">
                  <div className="flex justify-between items-end">
                    <label className="text-[11px] font-black text-slate-900 uppercase">Số lượng thành viên:</label>
                    <span className="text-2xl font-black text-sky-600">{groupSize} người</span>
                  </div>
                  <input type="range" min="1" max="25" value={groupSize} onChange={(e) => setGroupSize(e.target.value)} className="w-full h-2 bg-slate-100 rounded-lg appearance-none cursor-pointer accent-sky-600" />
                  
                  <div className="bg-slate-900 p-7 rounded-[35px] text-white shadow-xl transform transition-transform hover:scale-[1.02]">
                    <p className="text-[10px] uppercase opacity-40 font-black tracking-widest mb-1">Dự toán trọn gói - Tour bản địa</p>
                    <p className="text-4xl font-black tracking-tighter text-white">{totalTourCost.toLocaleString('vi-VN')} <span className="text-sm font-normal">VNĐ</span></p>
                  </div>
                  <div className="bg-sky-600 p-6 rounded-[30px] text-white">
                    <p className="text-[9px] uppercase opacity-80 font-black mb-1">Dự toán Tour HDV</p>
                    <p className="text-4xl font-black tracking-tighter">{(totalTourCost + selected.guider).toLocaleString('vi-VN')} <span className="text-xs">VNĐ</span></p>
                  </div>
                </div>

                <div className="space-y-6">
                  <label className="text-[11px] font-black text-slate-900 uppercase">Thông tin cơ bản:</label>
                  <div className="flex gap-3">
                   <p className="flex-1 py-2.5 border-2 border-white/60 bg-white/40 backdrop-blur-md rounded-[20px] font-extrabold text-[11px] uppercase text-slate-800 text-center shadow-sm">
                      {selected.date.toLocaleString('vi-VN')} VNĐ
                    </p>
                  </div>
                  {groupSize <= 8 ? (
                  <div className="p-5 bg-orange-50 rounded-[28px] border border-orange-100 flex items-start gap-3">
                    <span className="text-xl">🚌</span>
                    <div>
                      <p className="text-[10px] font-black text-orange-600 uppercase mb-1 tracking-widest">Xe đưa đón</p>
                      <p className="text-sm font-bold text-slate-700 italic leading-tight">{selected.bus}</p>
                    </div>
                  </div>): (
                  <div className="p-5 bg-orange-50 rounded-[28px] border border-orange-100 flex items-start gap-3">
                    <span className="text-xl">🚌</span>
                    <div>
                      <p className="text-[10px] font-black text-orange-600 uppercase mb-1 tracking-widest">Xe đưa đón</p>
                      <p className="text-sm font-bold text-slate-700 italic leading-tight">{selected.car}</p>
                    </div>
                    
                    <p className={`flex-1 py-4 rounded-[22px] font-black text-[11px] uppercase border-2 transition-all duration-300 `}
                      >
                        {selected.date}
                      </p>
                  </div>)}
                </div>
              </div>

              {/* LỊCH TRÌNH CHINH PHỤC CHI TIẾT */}
              <div className="pt-10 border-t border-slate-50 space-y-10">
                <div className="flex items-center gap-4">
                  <span className="w-2 h-10 bg-slate-900 rounded-full"></span>
                  <h3 className="text-3xl font-black text-slate-900 uppercase tracking-tighter">
                    Lịch trình {selected.name} <span className="text-sky-500 italic">({selected.date})</span>
                  </h3>
                </div>
                
                {/* HIỂN THỊ COMPONENT LỊCH TRÌNH TƯƠNG ỨNG */}
                <div className="bg-white rounded-[45px] border border-slate-100 p-4 md:p-10 shadow-sm min-h-[450px]">
                  <div className="animate-in fade-in slide-in-from-bottom-8 duration-1000">
                    <ActiveSchedule days={days} groupSize={groupSize} />
                  </div>
                </div>

                {/* TIMELINE TRANG BỊ */}
                <div className=" border border-sky-100">
                  <p className="text-[10px] font-black text-sky-700 uppercase  ">Danh sách dịch vụ</p>
                  <Timeline groupSize={groupSize} days={days} />
                </div>
              </div>

              {/* NÚT KÊU GỌI HÀNH ĐỘNG */}
              <button 
                onClick={() => window.open('https://www.facebook.com/leminhofhaiduong')}
                className="w-full mt-14 py-7 bg-slate-900 text-white rounded-[32px] font-black uppercase tracking-[0.2em] text-xs shadow-[0_20px_40px_rgba(0,0,0,0.3)] hover:bg-sky-600 hover:scale-[1.02] active:scale-95 transition-all duration-500"
              >
                Gửi yêu cầu & Nhận báo giá chi tiết
              </button>
            </div>
            
            <p className="text-center text-white/30 text-[10px] font-black uppercase tracking-[0.5em] py-10">
              Quick Trek — Chạm vào đỉnh cao — 2026
            </p>
          </div>
        </div>
      </div>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 10px; }
      `}</style>
    </div>
  );
}